import { Button, Stack } from 'components';
import { useFormikContext } from 'formik';
import { useLocation, useNavigate } from 'react-router-dom';
import { useHasUnsavedChanges } from 'utils/hooks/useHasUnsavedChanges';
import { useResponsive } from 'utils/hooks/useMediaQuery';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getSites } from 'store/clientProfile/clientProfileActions';
import { useEffect } from 'react';

import { FormValues } from '../clientForm';
import { Demographics } from './demographics/index';
import { ContactInfo } from './emergencyContact';
import PersonalDetails from './personalDetails/personalDetails';
import { Referral } from './referral';
import { SupportSystem } from './supportSystem';
import { Insurance } from './insurance';
import Billing from './billing/billing';
import CareGaps from './careGaps/careGaps';

const Profile = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isNewClientPage = pathname === '/clients/new/profile';
  const { isTablet } = useResponsive();
  const { handleSubmit, submitCount, dirty, isValid, submitForm, isSubmitting, values } =
    useFormikContext<FormValues>();
  const billingConfig = useAppSelector((state) => state.clientProfile.billingConfig.data);
  const { enableBillingUpdates } = useFlags();
  const dispatch = useAppDispatch();

  useHasUnsavedChanges(
    {
      isValid,
      submitForm
    },
    submitCount === 0 ? dirty : false
  );

  useEffect(() => {
    dispatch(getSites());
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      <Stack
        pr={isTablet ? '0px' : '19px'}
        py={isTablet ? '0px' : '12px'}
        gap="8px"
        flex={8}
        sx={{
          overflow: isTablet ? 'auto' : 'scroll',
          maxHeight: isTablet ? 'auto' : '100vh'
        }}
      >
        <PersonalDetails />
        <ContactInfo />
        <SupportSystem />
        <Referral />
        {enableBillingUpdates && <Insurance />}
        {enableBillingUpdates && billingConfig.enableBilling && <Billing />}
        <CareGaps />
        <Demographics />
        <Stack
          width="100%"
          display="flex"
          flexDirection="row"
          flex={2}
          justifyContent="end"
          data-test-id="profile-info-save"
        >
          <Stack
            width={isTablet && isNewClientPage ? '100%' : '100px'}
            display={isTablet ? 'flex' : 'block'}
            flexDirection="row"
            gap="8px"
          >
            {isTablet && isNewClientPage && (
              <Button
                handleOnClick={() => navigate('/clients')}
                text="Cancel"
                theme="transparent"
              />
            )}
            <Button
              disabled={!isValid || isSubmitting || !!values.duplicatedClient}
              text="Save"
              theme="primary"
            />
          </Stack>
        </Stack>
      </Stack>
    </form>
  );
};

export default Profile;
